/** Helpers shared by the Network tabs and their cards — extracted from the
 *  former single-page `pages/network.tsx` when it split into tabs (#310). */
import { toast } from "sonner";

export function copyToClipboard(value: string) {
  navigator.clipboard.writeText(value).then(
    () => toast.success("Copied!"),
    () => toast.error("Failed to copy"),
  );
}

export function cidrToDottedNetmask(cidr: number): string {
  const mask = ~((1 << (32 - cidr)) - 1) >>> 0;
  return [
    (mask >>> 24) & 0xff,
    (mask >>> 16) & 0xff,
    (mask >>> 8) & 0xff,
    mask & 0xff,
  ].join(".");
}

export function prefixBase(prefix: string): string {
  return prefix.split(".").slice(0, 3).join(".");
}

/** The conventional DHCP pool for a tenant network, derived from its prefix.
 *
 *  Unsourced by design — the portal has no endpoint for `DHCPPool.ranges`
 *  yet, and every pool sampled on prod is exactly `x.x.x.50-254`. The wider
 *  #310 work replaces this with the real range from the backend; until then
 *  the Make-static dialog and the Network Information card derive it HERE, in
 *  one place, so they can never disagree with each other. */
export function conventionalDhcpPool(prefix: string): { start: string; end: string } {
  const base = prefixBase(prefix);
  return { start: `${base}.50`, end: `${base}.254` };
}

/** HTTP status of a react-query error (axios), or undefined for non-HTTP errors. */
export function errorStatus(e: unknown): number | undefined {
  return (e as { response?: { status?: number } } | null)?.response?.status;
}

export function supportLink(subject: string, message: string): string {
  return `/contact?subject=${encodeURIComponent(subject)}&message=${encodeURIComponent(message)}`;
}
